import { MEETINGS_AI_BACK_URL } from "@/config";
import { TAIGetTranscriptResponse, TAISessionInsights } from "@/models/call.center.model";
import { getUserTimezone } from "@/utils/dates";
import axios from "axios";

const axiosMeetingsAi = axios.create({
    baseURL: MEETINGS_AI_BACK_URL,
});

axiosMeetingsAi.interceptors.request.use((config) => {
    config.headers['X-Timezone'] = getUserTimezone();
    return config;
});
type SentimentAnalysisStartSessionResponse = {
    success: boolean;
    session_id: string;
    status: string;
    websocket_urls: {
        audio_lead: string;
        audio_agent: string;
        transcript: string;
        audio_format: string;
        client: string;
    };
    instructions: {
            audio: {
        multi_speaker: string;
        message_format: {
                type: string;
                data: string;
                timestamp_ms: number;
            };
            transcript: {
                type: string;
                speaker: string;
                text: string;
                start_ms: number;
                end_ms: number;
            };
        };
    };
};


type AskAiSessionHistoryResponse = {
    id: number;
    assistant_message: string;
    user_message: string;
    created_at: string;
}


export const startSentimentAnalysisSession = async (
    sessionId: string,
    platform: "zoom" | "twilio" = "zoom",
): Promise<SentimentAnalysisStartSessionResponse> => {
    const response = await axiosMeetingsAi.post("/api/realtime/session/start", {
        session_id: sessionId,
        platform,
    });
    return response.data;
};

export const stopSentimentAnalysisSession = async (sessionId: string) => {
    const response = await axiosMeetingsAi.post(`/api/realtime/session/stop/${sessionId}`);
    return response.data;
};


export const sendVoiceTranscript = async (
    sessionId: string,
    speaker: string,
    text: string,
    start_ms: number,
    end_ms: number,
): Promise<void> => {
    await axiosMeetingsAi.post("/api/realtime/twilio/transcript", {
        session_id: sessionId,
        speaker,
        text,
        start_ms,
        end_ms,
    });
};

export const getAiSessionTranscript = async (sessionId: string): Promise<TAIGetTranscriptResponse> => {
    const response = await axiosMeetingsAi.get(`/api/realtime/transcript/${encodeURIComponent(sessionId)}`);
    return response.data;
}

export const getAiSessionInsights = async (sessionId: string): Promise<TAISessionInsights> => {
    const response = await axiosMeetingsAi.get(`/api/realtime/session/${encodeURIComponent(sessionId)}/insights`);
    return response.data;
}

export const askAiSession = async (sessionId: string, question: string): Promise<string> => {
    const response = await axiosMeetingsAi.post(`/api/realtime/ask/${encodeURIComponent(sessionId)}`, { question });
    return response.data.answer;
}

export const getAskAiSessionHistory = async (sessionId: string): Promise<AskAiSessionHistoryResponse[]> => {
    const response = await axiosMeetingsAi.get(`/api/realtime/chat-history/${encodeURIComponent(sessionId)}`);
    return response.data.chat_history;
}